
import {errorHttpMessage} from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'
import {makeRestoreAction} from '@/utils/catalogRestoreAction'

export const saveDisabilityType = async ({commit}, disability) => {
    try{
        const { data:result } = await configurationClient.post('/catalog/incapacityType/create', disability)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const findDisabilityTypeById = async ({commit}, disabilityId) => {
    try{        
        const { data:result } = await configurationClient.get(`/catalog/incapacityType/show/${disabilityId}`)        
        const { data, message, error } = result.result    
        return {data, message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const editDisabilityType = async ({commit}, disability) => {
    try{
        const { data:result } = await configurationClient.post(`/catalog/incapacityType/${disability.id}`, disability)        
        const { message, error } = result.result    
        return { message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const deleteDisabilityType = async ({commit}, disabilityId) => {
    try{        
        const { data:result } = await configurationClient.delete(`/catalog/incapacityType/destroy/${disabilityId}`)        
        const { message, error } = result.result    
        return {message, error}        
    } catch(ex) {                     
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const downloadExcelReport = async ({commit}, fileName) => {
    try{        
        const response = await configurationClient.get(`/catalog/incapacityType/download`,{
            responseType: 'blob'
        })                
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.xlsx`); //or any other extension
        document.body.appendChild(link);
        link.click();
    } catch(ex) {                             
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    } 
}

export const restoreById = makeRestoreAction(configurationClient, '/catalog/incapacityType')
